export const slugify = (str: string | undefined) => {
  if (!str) return "";

  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "_")
    .replace(/^-+|-+$/g, "");
};

export const capitalizeString = (str: string): string => {
  if (!str) return "";

  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};

export const capitalize = (str: string): string => {
  // "QWEQWEQWE" -> "Qweqweqwe"
  if (!str) return "";

  return str[0].toUpperCase() + str.slice(1).toLowerCase();
};

const MAINTENANCE_MODE_TRUE_VALUE = "true";

export const isMaintenanceMode = (): boolean => {
  const maintenanceMode = window.localStorage.getItem("maintenance-mode");

  return (maintenanceMode && maintenanceMode === MAINTENANCE_MODE_TRUE_VALUE) as boolean;
};

export const someValueInFormIsEmpty = (form: object, exceptions?: Array<string>): boolean => {
  return Object.keys(form).some((key) => {
    if (exceptions.includes(key)) return false;

    return !form[key];
  });
};

export const encodeUrlParams = (params: URLSearchParams) => {
  return Object.keys(params).reduce((acc, key) => {
    acc[key] = encodeURIComponent(params[key]);

    return acc;
  }, {});
};

export const serializeAndEncodeUrlParams = (params: URLSearchParams) => {
  return Object.entries(params)
    .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join("&");
};
